module.exports = __webpack_public_path__ + "assets/videos/video-header-desktop.mp4?v=e51931ac";